
import React from 'react';
import PropTypes from 'prop-types';

import Translatable from '../../../../../../../components/Translatable';

const inverseWalkingSpeeds = {
    METER: 0.0120,
    FEET: 0.0037
};

const distanceToWalkingMinutes = ({ unit, value }) =>
    Math.round(inverseWalkingSpeeds[unit] * value);

const PlaceInner = ({ place }) => {
    const mins = distanceToWalkingMinutes(place.distance);
    return (
        <React.Fragment>
            {`${place.name} · `}
            <Translatable
                content={{
                    transKey: 'common.minutes_count',
                    count: mins,
                    replacements: {
                        number: mins
                    }
                }}
            />
        </React.Fragment>
    );
};

PlaceInner.propTypes = {
    place: PropTypes.object.isRequired
};

export default PlaceInner;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/PlaceInner/PlaceInner.jsx